import { analytics } from '@saucelabs/sl-util-axios';

/**
 * @param {Object} params
 * @param {array}  params.{string} - Filters are passed as a string key and value as an array.
 */
export function getTestCase(params) {
  return analytics.get('/tests/cases', { params });
}
